import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { XClose } from "untitledui-js-base";
import { ActivitiesList } from "./ActivitiesList";
import Drawer from "react-modern-drawer";
import { useActivityLogsController } from "shared/queries/useActivityLogsController";
import { Loader } from "shared/components/Loader";
import { useMedia } from "shared/providers";

export const ActivityLog = ({
  showActivityLog,
  setShowActivityLog,
  applicationId,
  propertyName
}: {
  showActivityLog: boolean;
  setShowActivityLog: (value: boolean) => void;
  applicationId: string;
  propertyName?: string;
}) => {
  const { activityLogsMeta, addNoteMeta, editNoteMeta, deleteNoteMeta } =
    useActivityLogsController(applicationId);

  const { isMobile } = useMedia();

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      onClose={() => {
        setShowActivityLog(false);
      }}
      open={showActivityLog}
      size={isMobile ? 380 : 640}
    >
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-alpha-80 px-6 py-4">
          <p className="text-xl font-bold text-content-1000">Activity log</p>
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            borderLess
            className="!justify-end stroke-content-1000 !p-0"
            onClick={() => setShowActivityLog(false)}
          >
            <XClose size="24" />
          </Button>
        </div>

        <div className="flex-grow overflow-y-auto">
          {activityLogsMeta.isLoading ? (
            <div className="flex items-center justify-center pt-10">
              <Loader />
            </div>
          ) : (
            <ActivitiesList
              propertyName={propertyName}
              addNoteMeta={addNoteMeta}
              editNoteMeta={editNoteMeta}
              deleteNoteMeta={deleteNoteMeta}
              activityLogs={activityLogsMeta.data || []}
              applicationId={applicationId}
            />
          )}
        </div>
      </div>
    </Drawer>
  );
};
